import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterRole} from '../../../redux/slices/filterSlices'
import * as TableUI from '../../../components/Table/Table'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {filterRole: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterRole({...filter, ...value}))
  }

  return (
    <TableUI.TRowFilter>
      <td>
        <div style={{border: 0, padding: '13px 0px 10px 0px'}}>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('nama')}
          value={filter?.name ?? ''}
          onChange={({target}) => handleFilterChange({...filter, name: target.value})}
        />
      </td>
    </TableUI.TRowFilter>
  )
}
